import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "antd";

import "swiper/css/bundle";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

const Carousel = ({ slides }) => {
  const navigate = useNavigate();
  
  const badgePreview = (id, badge) => {
    if (badge.isEarned) {
      // Track badge click event in GA4
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'badge_click',
        'badge_id': id,
        'badge_name': badge.name,
        'badge_category': badge.categoryId,
        'is_earned': badge.isEarned,
        'user_id': localStorage.getItem("yinzcamId") || localStorage.getItem("secretKey") || 'anonymous',
        'user_email': localStorage.getItem("email") || 'anonymous',
        'click_timestamp': new Date().toISOString(),
        'device_type': window.location.pathname.includes("main-desktop") ? 'desktop' : 'mobile',
      });
        // 'ga4_measurement_id': 'G-EC4X5M443P'



      // if (window.gtag) {
      //   window.gtag('event', 'badge_click', {
      //     'badge_id': id,
      //     'badge_name': badge.name,
      //     'badge_category': badge.categoryId,
      //     'is_earned': badge.isEarned,
      //     'user_id': localStorage.getItem("yinzcamId") || localStorage.getItem("secretKey") || 'anonymous',
      //     'user_email': localStorage.getItem("email") || 'anonymous',
      //     'click_timestamp': new Date().toISOString(),
      //     'device_type': window.location.pathname.includes("main-desktop") ? 'desktop' : 'mobile'
      //   });
      // }

      const isDesktop = window.location.pathname.includes("main-desktop");
      const path = isDesktop ? `/badge-desktop/${id}?isEarned=${badge.isEarned}` : `/badge/${id}?isEarned=${badge.isEarned}`;
      navigate(path, { state: { badge } });
    }
  };

  return (
    <Swiper
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
      slidesPerView="auto"
      breakpoints={{
        320: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20
        }
      }}
      grid={{
        rows: 1,
      }}
      pagination={{
        clickable: true,
      }}
      className="mySwiper"
    >
      {slides.map((slide, index) => (
        <SwiperSlide
          key={slide.id}
          onClick={() => badgePreview(slide.id, slide)}
          style={{ width: 'auto' }}
        >
          <Tooltip
            title={
              slide.hoverDescription && !slide.isEarned
                ? slide.hoverDescription.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")
                : ""
            }
          >
            <div 
              className="slide-content" 
              style={{ 
                marginTop: "10px",
                width: "100%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <img
                src={slide.imageURL}
                alt={slide.altText || `Slide ${index + 1}`}
                style={{
                  width: "100%",
                  maxWidth: "100px",
                  height: "auto",
                  objectFit: "contain",
                  opacity: slide.isEarned ? "1" : "0.3",
                }}
              />
            </div>
          </Tooltip>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Carousel;
